import { useMemo } from 'react';
import { RouteObject, useRoutes as useReactRoutes } from 'react-router-dom';
import { OrganizationMembershipResponse } from '@/shared/api';
import { PrivateRoute, PublicRoute } from '../ui';

export type AppRouteObject = RouteObject & {
  isPrivate?: boolean;
  allowedRoles?: Array<OrganizationMembershipResponse['role']>;
};

export const useRoutes = (routes: AppRouteObject[]) => {
  const mappedRoutes: RouteObject[] = useMemo(
    () =>
      routes.map(({ element, isPrivate, allowedRoles, ...rest }) => {
        const RouteConstructor = isPrivate ? PrivateRoute : PublicRoute;
        const wrappedElement = (
          <RouteConstructor allowedRoles={allowedRoles} element={element} />
        );
        return { element: wrappedElement, ...rest };
      }),
    [routes],
  );

  return useReactRoutes(mappedRoutes);
};
